import { cashAccounts } from '../cashAccount'
import { describeTable } from './describeTable'

describeTable(cashAccounts, {
  description: `A place where a company's money sits: a bank account. The daily cash forecast (finance.cashFlowDaily) starts from the latest cash_balances row of each account and adds cash_events after it. Stripe is a timing model, not a cash account: card income is dated on the day it reaches the bank (settlement plus the next Monday payout) and booked in at company level, with no account_id of its own, so there is no Stripe account row and no transfer legs for it. Visible cash therefore excludes up to one payout cycle of Stripe float, which errs low.`,
  columns: {
    kind: "bank = a bank account. The enum keeps a 'stripe' value, but no row uses it — see the description.",
    iban: 'IBAN for bank accounts.',
    openingBalance:
      'Seed-era closing balance on opening_balance_date. Superseded by cash_balances once a row exists there.',
    openingBalanceDate: 'The day whose closing balance opening_balance is.',
    ledgerAccount:
      "Account number in the company's chart of accounts (Fennoa), e.g. 1910 Pankkitili 1. Used to read the booked balance.",
    voucherSeries:
      'Fennoa voucher series of bank statement bookings, e.g. BA1. Ledger rows in this series tell how far the statement has been booked.',
  },
})
